import axionIns from "../axios";
import service from "./service";

const categoryList = async (search, page, limit) => {
  return service
    .get(`admin/categories?search=${search}&page=${page}&limit=${limit}`)
    .then((response) => {
      return response;
    });
};

const categoryListDelete = async (id) => {
  return service.deleteApi(`admin/categories/${id}`).then((response) => {
    return response;
  });
};

const allCategoryList = async () => {
  return service.get(`admin/all-categories-list`);
};


const categoryAdd = async (payload) => {
  return service.post(`admin/categories`, payload).then((response) => {
    return response;
  });
};

const getCategoryById = async (id) => {
  return service.get(`admin/categories/${id}`).then((response) => {
    return response;
  });
};

const editCategory = async (id, payload) => {
  return service.patchApi(`admin/categories/${id}`, payload).then((response) => {
    return response;
  });
};
const uploadFile = (payload) => {
  return axionIns.post("upload", payload); // ✅ no headers needed
};

export default {
  categoryList,
  allCategoryList,
  categoryListDelete,
  categoryAdd,
  getCategoryById,
  editCategory,
  uploadFile,
};
